// extracted by mini-css-extract-plugin
export default {"valueLink":"SurveyScopeValues_valueLink__kctsa","placeHolderShimmer":"SurveyScopeValues_placeHolderShimmer__QtQ0S"};